import { render, staticRenderFns } from "./Delegates.vue?vue&type=template&id=ed5b8d16&scoped=true"
import script from "./Delegates.vue?vue&type=script&lang=js"
export * from "./Delegates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5b8d16",
  null
  
)

export default component.exports